import classNames from 'classnames';
import { debounce } from 'lodash';
import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { FormFieldBase } from '.';
import { getFieldProperties, getFieldPropertyValues } from './helpers';
import * as FormProperties from './properties-config';
import ValidationMessage from './validation-message';

export class FormFieldSignature extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isShow: true
    };

    this.handleResize = debounce(this.handleResize, 200);
  }

  componentDidMount() {
    const { readOnly } = this.props;

    if (!this.signatureEl) return;

    if (readOnly) this.signatureEl.off(); // unbinds all event handlers
    else this.signatureEl.on(); // rebinds all event handlers

    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate() {
    const { value } = this.props;

    if (!this.signatureEl) return;

    if (value) {
      this.signatureEl.clear();
      this.signatureEl.fromDataURL(decodeURIComponent(value));
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const { value } = this.props;

    if (!value || !this.signatureEl || !this.signatureEl.isEmpty()) return;

    if (value) {
      this.signatureEl.fromDataURL(decodeURIComponent(value));
    }
  };

  handleDrawEnd = e => {
    const { field, onChange } = this.props;
    // customize event object to add a value property
    // NOTE: spreading e (MouseEvent) not working (why?),
    // so just building minimal object needed to pass to onChange method
    const event = {
      target: {
        id: field.uuid,
        value: encodeURIComponent(this.signatureEl.toDataURL()),
      },
    };

    onChange(event);
  };

  handleClear = () => {

    const { field, readOnly, onChange } = this.props;

    const event = {
      target: {
        id: field.uuid,
        value: '',
      },
    };
    if (!readOnly) {
      this.signatureEl.clear();
      onChange(event);

      this.setState(prev => ({...prev, isShow: true}));
    }
  };

  sublabel = field => {
    const localProps = new Map(FormProperties.Signature);
    const propertyNames = ['sublabel'];
    const defaultValues = propertyNames.map(propName => ({
      [`${propName}`]: localProps.get(propName).defaultValue,
    }));
    const properties = getFieldProperties(field, 'specific');
    const { sublabel } = getFieldPropertyValues(properties.specific, propertyNames, defaultValues);

    if (sublabel) return <div className='form-field-label secondary'>{sublabel}</div>;
  };

  render() {
    const { field, className, commonProps, isRenderedField, validationMessage } = this.props;
    const classes = classNames({
      [className]: true,
      signature: true,
      'control-group error': validationMessage,
    });

    return (
      <div className={classes}>
        <div className='form-field-label primary'>{`${commonProps.label} ${commonProps.makeRequired ? '*' : ''
          }`}</div>
        <div className='form-field-input'>
          <div
            className={`signature ${!isRenderedField ? 'span30' : ''}`}
          >
            {!isRenderedField && <span>Signature Area</span>}
            {isRenderedField && this.state.isShow && (
              <SignatureCanvas
                ref={el => (this.signatureEl = el)}
                canvasProps={{
                  id: field.uuid,
                  className: 'signature-canvas',
                }}
                onEnd={this.handleDrawEnd}
              />
            )}
          </div>
          <div className='form-field-footer' style={{ width: '100%' }}>
            {this.sublabel(field)}
            <div className='clear' onClick={this.handleClear}>
              <span title='Clear signature'>Clear</span>
            </div>
          </div>
        </div>
        <ValidationMessage message={validationMessage} />
      </div>
    );
  }
}

FormFieldSignature.defaultProps = {
  className: '',
  commonProps: {},
  isRenderedField: false,
  onChange: () => { },
  onBlur: () => { },
  value: '',
  readOnly: false,
};

export default FormFieldBase(FormFieldSignature);
